
define('text!modules/audiences/pixels/templates/select_status.html',[],function () { return '<strand-dropdown placeholder="Active" fitparent class="select-filter select-status">\n\t<strand-list-item value="1">Active</strand-list-item>\n\t<strand-list-item value="0">Inactive</strand-list-item>\n\t<strand-list-item value="both">All</strand-list-item>\n</strand-dropdown>\n';});

